// import NewOfferingButton, {EditOfferingButton, DeleteOfferingButton} from 'components/NewOfferingButton';
import NewCouponButton, {EditCouponButton, DeleteCouponButton} from 'components/coupons/NewCouponButton';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import ReactTable from 'react-table';
import { Route, Switch, useLocation, useHistory, Link } from "util/router.js";
import {loadCoupons} from 'store/actions/couponActions'
import {loadOfferings} from 'store/actions/offeringsActions'
import {Helmet} from 'react-helmet'
import ShareButton from 'components/ShareButton'
import OfferingSection from 'components/OfferingSection';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Section from 'components/Section'
import moment from 'moment-timezone'
import Redemptions from 'pages/coupons/redemptions'
import { IconButton } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ReactDOM from 'react-dom'
import Button from "components/CustomButtons/Button.js";
import { CSVLink, CSVDownload } from 'react-csv';
// import IconButton from '@material-ui/core/IconButton';

const BASE_URL = process.env.REACT_APP_BOOKING_SUCCESS_URL

function CouponsTable(props) {

  const location = useLocation();
  const history = useHistory()
  const [key, setKey] = React.useState(location.hash ? location.hash.replace("#", "") : "promotions");

  const {selectedOffering} = props

  const coupons = useSelector(state => state.instructor.coupons);
  const widgetName = useSelector(state => state.instructor.instructor.widgetName)
  const currency = useSelector(state => state.instructor.instructor?.instructorProfile?.currency ?? "USD")
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  });

  // console.log("LOCATIUON: ", location)

  const tableData = coupons.sort((a,b) => {
    if (a.deleted && !b.deleted) {
      return 1
    } else if (!a.deleted && b.deleted) {
      return -1
    }
    return 0
  }).map(val => {

    const actions = (
      // we've added some custom button actions
      <div className="d-flex d-row align-items-center justify-content-end">

          {(val.deleted) && (
            <span>Deleted</span>
          )}
          <Link
          to={`${location.pathname}/c/${val.id}`}
          >
              <IconButton>
                  <VisibilityIcon/>    
              </IconButton>
          </Link>
          {(val.deleted || val.discount_type === 'gift') ? <></> : (<>

            <EditCouponButton 
            {...props}
            toEdit={val}
            />
            <DeleteCouponButton 
            toDelete={val}
            />
          </>
          )}
      </div>
    )
    const clickableName = (
        <div className="d-flex d-row align-items-center">
        <a href="#" onClick={(e) => {
          e.preventDefault()
          if (selectedOffering) {
            selectedOffering(val)
          }
          // history.push(`${baseUrl}/class/${key}`)
      }}>
          {val.code}
      </a>
      {!val.active && (
        <div style={{
            backgroundColor: "#fbeeca",
            color: "black",
            borderRadius: "4px"
          }}
          className="px-2 py-1 ml-2"
          >
            Private
        </div>

      )}
      {val.isOneTimeOffer && (
        <div style={{
            backgroundColor: "#dae8cc",
            color: "black",
            borderRadius: "4px"
          }}
          className="px-2 py-1 ml-2"
          >
            Intro
        </div>

      )}
      </div>
    )
    

    return {
      ...val,
      actions: actions,
      clickableName: clickableName,
      total_amount: val.discount_amount
    }
  })

  const promotionData = tableData.filter(val => {
    return ["percentage", "amount"].includes(val.discount_type)
  }).map(val => {
    // console.log(val)
    val.discount_amount = val.discount_type === "percentage" ? (<>
      <span>{val.discount_amount}%</span>
    </>) : (<>
      <span>{currencyFormatter.format(val.discount_amount)}</span>
    </>)

    return val
  })

  const giftData = tableData.filter(val => {
    return ["gift"].includes(val.discount_type)
  }).map(val => {
    // console.log(val)
    val.discount_amount = (<>
      <span>Amount: {currencyFormatter.format(val.discount_amount)}</span><br></br>
      <span>Remaining: {currencyFormatter.format(val.discount_amount_remaining)}</span>

    </>)

    return val
  })

  const tableColumns = [
      {
      Header: "Code",
      accessor: "code",
      minWidth: 150
      },
      // {
      // Header: "Type",
      // accessor: "discount_type",
      // minWidth: 150
      // },
      {
      Header: "Percent / Amount",
      accessor: "discount_amount",
      minWidth: 100,
      filterable: false
      },
      {
      Header: "Expiration",
      accessor: "expires_at",
      width: 100,
      Cell: row => <span>{moment(row.value * 1000).format('LL')}</span>,
      filterable: false
      },
      {
      Header: "Actions",
      accessor: "actions",
      sortable: false,
      width: 200,
      filterable: false
      }
  ]

  const handleExportGiftCards = () => {
    const headers = [
      { label: "Code", key: "code" },
      { label: "Amount", key: "discount_amount" },
      { label: "Amout Remaining", key: "discount_amount_remaining" },
     
    ]
    const cleanedData = giftData.map(val => {
      return {
        code: val.code,
        discount_amount: val.total_amount,
        discount_amount_remaining: val.discount_amount_remaining
      }
    })
    const element = (<CSVDownload filename={`${"export_codes"}.csv`} data={cleanedData} headers={headers} target="_blank" />);

    ReactDOM.render(element, document.querySelector('#export-gifts-div'));

  }

  return (
  <div>
    <Tabs
    id="controlled-tab-example"
    activeKey={key}
    onSelect={(k) => {
        history.push(location.pathname + `#${k}`)
        setKey(k)
    }}
    >
      <Tab eventKey="promotions" title="Promotions">
        <Section>
          {/* {promotionData.length > 0 ? ( */}
          {true ? (
            <ReactTable
            data={promotionData}
            filterable={true}
            columns={tableColumns}
            defaultPageSize={10}
            showPaginationTop={false}
            showPaginationBottom={true}
            className="-highlight"
            />
          ) : (
            <div className="h-100 text-center">
              {/* <h3 className="font-weight-bold">Create a new package / sub</h3>
              <p>Get started now</p>
              <NewCouponButton {...props}/> */}

            </div>
          )}
        </Section>
      </Tab>
      <Tab eventKey="gifts" title="Gifts">
        <Section>
          {/* {giftData.length > 0 ? ( */}
        {true ? (
          <>
          <div className="d-flex flex-row-reverse">
            <Button onClick={handleExportGiftCards} size={"sm"}>Export to CSV</Button>
            <div id='export-gifts-div'></div>
          </div>
            <ReactTable
            data={giftData}
            filterable={true}
            columns={tableColumns}
            defaultPageSize={10}
            showPaginationTop={false}
            showPaginationBottom={true}
            className="-highlight"
            />
          </>
          ) : (
            <div className="h-100 text-center">
              {/* Deleted offerings will show here
              <h3 className="font-weight-bold">Create a new package / sub</h3>
              <p>Get started now</p>
              <NewCouponButton {...props}/> */}

            </div>
          )}
        </Section>
      </Tab>
    </Tabs>
  </div>
  )
}


function CouponsPage(props) {

  const {match } = props;
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch();
  const partnerId = useSelector(state => state.instructor.instructor.platformID);
  const partner = useSelector(state => state.instructor.instructor);
  useEffect(() => {
    // dispatch
    if (partnerId) {
      dispatch(loadOfferings())
      dispatch(loadCoupons())
    }
    
  }, [dispatch, partnerId]);

  function Packages() {

    const shareLink = "https://sutrapro.com/" + (partner?.widgetName ?? "") + "/gifting"
    return (<>

    <Helmet>
      <title>Coupons</title>
    </Helmet>
    <div className="container px-0 "  >
      {true && (
        <section>
          <div className='d-flex d-row justify-content-between align-items-center mb-4'>
            <h2 className="font-weight-bold">🎁✨&nbsp;Gifts &amp; Promotions</h2>
            <NewCouponButton className="float-right" {...props}/>
          </div>
          {/* <p><big>Create additional ways for your students to pay. Packs &amp; subscriptions are a great way to build student loyalty and increase retention.</big></p> */}
          <p><big>Use a promo code to offer a flash sale or quick discount to a student.  Selling gift cards are a great way for your students to share your classes with friends &amp; Family!</big></p>
          <div className="d-flex align-items-baseline">
            <h4 className="font-weight-bold mr-2">Share Gifting Page</h4>
            <div className="d-flex d-row align-items-center">
                  
                <input
                style={{paddingRight: "50px"}}
                type="text" value={shareLink} readOnly={true} className={"form-control"}/>
                <ShareButton link={shareLink} 
                style={{marginLeft: "-50px"}}
                />
            </div>
          </div>
          <div className="d-flex align-items-baseline">
          
            <button className="btn btn-link p-0" onClick={() => history.push("/dashboard/settings#public-page")}>
              <h5 className="font-weight-bold primaryColor p-0">Embed in your website</h5>
            </button>
          </div>
          <CouponsTable
            {...props}
            history={history}
            baseUrl={match.url}
          //   selectedOffering={offering => {
          //     history.push(`${props.match.url}/c/${offering.id}`)
          //   }}
            />
        </section>

      )}
    </div>
    </>
    );
  }

  return (
    <Switch>
      <Route path={`${props.match.url}/c/:couponId`} component={Redemptions} />

      <Route path="/">
        <Packages />
      </Route>
    </Switch>
  );
}

export default CouponsPage;
